import { useMemo } from "react";
import { useThemeMode } from "./use-theme-mode";

/**
 * The current value of a color token, for SVG presentation attributes such
 * as stroke= and stopColor=, and for chart library props. Chrome resolves
 * var() in those attributes, but not every browser does, so these places
 * get a plain color. The value is read once per color mode.
 *
 * @param variable A custom property name, e.g. "--color-dashboard-border".
 * @param fallback Returned when the property has no value, e.g. in tests.
 */
export function useThemeColor(variable: string, fallback: string): string {
	const { resolved } = useThemeMode();
	return useMemo(() => {
		// `resolved` is the dependency: the computed value changes with it.
		void resolved;
		const value = getComputedStyle(document.documentElement)
			.getPropertyValue(variable)
			.trim();
		return value || fallback;
	}, [variable, fallback, resolved]);
}
